/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ClothesShoesSneakersIcon16Light } from './ClothesShoesSneakersIcon16Light';
import { ClothesShoesSneakersIcon16Regular } from './ClothesShoesSneakersIcon16Regular';
import { ClothesShoesSneakersIcon16Solid } from './ClothesShoesSneakersIcon16Solid';
import { ClothesShoesSneakersIcon20Light } from './ClothesShoesSneakersIcon20Light';
import { ClothesShoesSneakersIcon20Regular } from './ClothesShoesSneakersIcon20Regular';
import { ClothesShoesSneakersIcon20Solid } from './ClothesShoesSneakersIcon20Solid';
import { ClothesShoesSneakersIcon24Regular } from './ClothesShoesSneakersIcon24Regular';
import { ClothesShoesSneakersIcon24Solid } from './ClothesShoesSneakersIcon24Solid';
import { ClothesShoesSneakersIcon32Regular } from './ClothesShoesSneakersIcon32Regular';
import { ClothesShoesSneakersIcon64Regular } from './ClothesShoesSneakersIcon64Regular';
var sizes = {
    16: {
        light: ClothesShoesSneakersIcon16Light,
        regular: ClothesShoesSneakersIcon16Regular,
        solid: ClothesShoesSneakersIcon16Solid,
    },
    20: {
        light: ClothesShoesSneakersIcon20Light,
        regular: ClothesShoesSneakersIcon20Regular,
        solid: ClothesShoesSneakersIcon20Solid,
    },
    24: {
        regular: ClothesShoesSneakersIcon24Regular,
        solid: ClothesShoesSneakersIcon24Solid,
    },
    32: {
        regular: ClothesShoesSneakersIcon32Regular,
    },
    64: {
        regular: ClothesShoesSneakersIcon64Regular,
    },
};
export var ClothesShoesSneakersIcon = forwardRef('ClothesShoesSneakersIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
